import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, Observable, shareReplay, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { API_URL } from '../tokens/api-url.token';
import { LoginData } from '../model/user-auth';

let refreshInFlight$: Observable<LoginData> | null = null;

export const apiInterceptor: HttpInterceptorFn = ( req: HttpRequest<unknown>, next: HttpHandlerFn) => {

  const authService = inject(AuthService);
  const router = inject(Router);
  const gatewayUrl = inject(API_URL);

  // Resolver URL del Gateway
  const fullUrl = req.url.startsWith('/')
    ? `${gatewayUrl}${req.url}`
    : req.url;

  const apiReq = req.clone({
    url: fullUrl
  });

  const isLogin = apiReq.url.includes('/api/v1/auth/login');
  const isRefresh = apiReq.url.includes('/api/v1/auth/refresh');

  const token = authService.token();

  const request = token && !isLogin && !isRefresh
    ? apiReq.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      })
    : apiReq;

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || isLogin || isRefresh) {
        return throwError(() => error);
      }

      if (!refreshInFlight$) {
        refreshInFlight$ = authService.refreshToken().pipe(
          shareReplay({ bufferSize: 1, refCount: false }),
          finalize(() => {
            refreshInFlight$ = null;
          })
        );
      }

      return refreshInFlight$.pipe(
        catchError((refreshError) => {
          authService.logout();
          router.navigate(['/login']);

          return throwError(() => refreshError);
        }),
        switchMap((response) => {
          authService.login(response.token);

          const retryRequest = apiReq.clone({
            setHeaders: {
              Authorization: `Bearer ${response.token}`
            }
          });

          return next(retryRequest).pipe(
            catchError((retryError: HttpErrorResponse) => {
              if (retryError.status === 401) {
                authService.logout();
                router.navigate(['/login']);
              }

              return throwError(() => retryError);
            })
          );
        })
      );
    })
  );
};
